import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Basic translations for admin panel
const resources = {
  en: {
    translation: {
      common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        add: 'Add',
        search: 'Search',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        confirm: 'Confirm',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        submit: 'Submit',
        close: 'Close',
        yes: 'Yes',
        no: 'No'
      },
      about: {
        title: 'About',
        mission: 'Mission',
        vision: 'Vision',
        story: 'Story',
        values: 'Values',
        history: 'History',
        description: 'Description',
        organization: 'Organization',
        established: 'Year Established',
        location: 'Location',
        country: 'Country',
        email: 'Email',
        phone: 'Phone',
        employees: 'Employees',
        male: 'Male',
        female: 'Female',
        total: 'Total',
        status: 'Status',
        logo: 'Logo',
        image: 'Image',
        heroImage: 'Hero Image'
      }
    }
  },
  per: {
    translation: {
      common: {
        save: 'ذخیره',
        cancel: 'لغو',
        delete: 'حذف',
        edit: 'ویرایش',
        add: 'افزودن',
        search: 'جستجو',
        loading: 'در حال بارگذاری...',
        error: 'خطا',
        success: 'موفقیت',
        confirm: 'تایید',
        back: 'بازگشت',
        next: 'بعدی',
        previous: 'قبلی',
        submit: 'ارسال',
        close: 'بستن',
        yes: 'بله',
        no: 'خیر'
      },
      about: {
        title: 'درباره',
        mission: 'مأموریت',
        vision: 'چشم‌انداز',
        story: 'داستان',
        values: 'ارزش‌ها',
        history: 'تاریخچه',
        description: 'توضیحات',
        organization: 'سازمان',
        established: 'سال تأسیس',
        location: 'موقعیت',
        country: 'کشور',
        email: 'ایمیل',
        phone: 'تلفن',
        employees: 'کارکنان',
        male: 'مرد',
        female: 'زن',
        total: 'مجموع',
        status: 'وضعیت',
        logo: 'لوگو',
        image: 'تصویر',
        heroImage: 'تصویر اصلی'
      }
    }
  },
  ps: {
    translation: {
      common: {
        save: 'خوندي',
        cancel: 'بندول',
        delete: 'ړنګول',
        edit: 'سمون',
        add: 'اضافه کول',
        search: 'لټول',
        loading: 'په بار کولو کې...',
        error: 'تېروتنه',
        success: 'بريا',
        confirm: 'تاييدول',
        back: 'شا',
        next: 'بل',
        previous: 'مخکنی',
        submit: 'لېږل',
        close: 'بندول',
        yes: 'هو',
        no: 'نه'
      },
      about: {
        title: 'په اړه',
        mission: 'ماموريت',
        vision: 'ليد',
        story: 'کيسه',
        values: 'ارزښتونه',
        history: 'تاريخچه',
        description: 'تشریح',
        organization: 'سازمان',
        established: 'تاسیس کال',
        location: 'موقعیت',
        country: 'هېواد',
        email: 'بريښليک',
        phone: 'تليفون',
        employees: 'کارمندان',
        male: 'نر',
        female: 'ښځه',
        total: 'ټول',
        status: 'وضعیت',
        logo: 'لوگو',
        image: 'انځور',
        heroImage: 'اصلي انځور'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: false, // Disable suspense mode for admin
    },
  });

export default i18n;
